import { ApolloLink } from '@apollo/client';

import { gqlFilterFields } from 'utils/gqlUtils';

/**
 * Custom link that will filter out unnecessary variables from gql operations. This is needed as the api will throw
 * errors if extra unneeded variables are sent in the request. Variables should still not include extra fields, but
 * this ensures the request won't fail because of that.
 */
export const filterFieldsLink = new ApolloLink((operation, forward) => {
  operation.variables = gqlFilterFields(operation.query, operation.variables) ?? {};

  return forward(operation);
});
